
import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAppContext } from './App.jsx';

// Importe todas as suas telas aqui
import ClientDashboard from './screens/client/ClientDashboard.jsx';
import ClientAppointmentScreen from './screens/client/ClientAppointmentScreen.jsx';
import ServiDashboard from './screens/servi/ServiDashboard';
import FluxoScreen from './screens/servi/FluxoScreen.jsx';
import FluxoListScreen from './screens/servi/FluxoListScreen.jsx';
import FaturamentoScreen from './screens/servi/FaturamentoScreen.jsx';
import ClientesPorPeriodoScreen from './screens/servi/ClientesPorPeriodoScreen.jsx';
import AgendaScreen from './screens/servi/AgendaScreen.jsx';
import PerfilScreen from './screens/PerfilScreen';
import ChatsListScreen from './screens/ChatsListScreen';
import ChatScreen from './screens/ChatScreen';
import MediaCaptureScreen from './screens/MediaCaptureScreen.jsx';
import RatingScreen from './screens/RatingScreen.jsx';
import ServiAcademyScreen from './screens/servi/ServiAcademyScreen.jsx';
import BottomNav from './components/common/BottomNav';
import TserviAssistant from './components/common/TserviAssistant.jsx';

const MainLayout = () => {
    const { activeRole, fullUserData, user } = useAppContext();
    const navigate = useNavigate();

    // Lógica para carregar a preferência de visibilidade do assistente
    const showAssistant = fullUserData?.preferences?.showAssistant !== false;

    const handleOpenChat = (chatId) => {
        const path = activeRole === 'servi' ? `/servi/chat/${chatId}` : `/chat/${chatId}`;
        navigate(path);
    };

    return (
        <div className="h-full flex flex-col relative overflow-hidden">
            <main className="flex-1 relative overflow-hidden">
                <Routes>
                    {activeRole === 'client' && (
                        <>
                            <Route path="/" element={<ClientDashboard onOpenChat={handleOpenChat} fullUserData={fullUserData} />} />
                            <Route path="/client/appointments" element={<ClientAppointmentScreen />} />
                            <Route path="/chats" element={<ChatsListScreen />} />
                            <Route path="/profile" element={<PerfilScreen userRole="client" fullUserData={fullUserData} />} />
                            <Route path="/avaliar" element={<RatingScreen />} />
                        </>
                    )}
                    {activeRole === 'servi' && (
                        <>
                            <Route path="/servi/dashboard" element={<ServiDashboard onOpenChat={handleOpenChat} fullUserData={fullUserData} />} />
                            <Route path="/servi/fluxo" element={<FluxoScreen />} />
                            <Route path="/servi/agenda" element={<AgendaScreen />} />
                            <Route path="/servi/fluxo/ativos" element={<FluxoListScreen isHistory={false} />} />
                            <Route path="/servi/fluxo/historico" element={<FluxoListScreen isHistory={true} />} />
                            <Route path="/servi/fluxo/faturamento" element={<FaturamentoScreen />} />
                            <Route path="/servi/fluxo/clientes" element={<ClientesPorPeriodoScreen />} />
                            <Route path="/servi/academy" element={<ServiAcademyScreen />} />
                            <Route path="/chats" element={<ChatsListScreen />} />
                            <Route path="/profile" element={<PerfilScreen userRole="servi" fullUserData={fullUserData} />} />
                             <Route path="/avaliar" element={<RatingScreen />} />
                        </>
                    )}
                    <Route path="*" element={<Navigate to={activeRole === 'client' ? '/' : '/servi/dashboard'} />} />
                </Routes>
            </main>

            {/* ASSISTENTE E NAV POSICIONADOS */}
            {user && activeRole && showAssistant && <TserviAssistant />}
            {user && activeRole && <BottomNav userRole={activeRole} />}
        </div>
    );
};

export default MainLayout;
